import { useLazyQuery } from '@apollo/client'
import {
  GetResultLabelConceptMappingsSuggestionsDocument,
  GetResultLabelConceptMappingsSuggestionsQuery,
} from 'generated/resources/graphql'

export type ResultLabelConceptMappingSuggestion =
  GetResultLabelConceptMappingsSuggestionsQuery['payroll']['resultLabelConceptMappingsSuggestionsConnection']['nodes'][number]

export const useResultLabelConceptMappingsSuggestions = () => {
  // https://www.apollographql.com/docs/react/data/queries#manual-execution-with-uselazyquery
  const [getResultLabelConceptMappingsSuggestions, { loading }] = useLazyQuery(
    GetResultLabelConceptMappingsSuggestionsDocument
  )

  return {
    loading,
    getResultLabelConceptMappingsSuggestions,
  }
}
